import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  format,
  getYear,
} from 'date-fns';

import { RoomAttributes } from 'lib/models/candidate-messages';
import { CompanyAttributes, CompanyResponse } from 'lib/models/company';
import { OpportunityResponse } from 'lib/models/opportunity';
import {
  StudentSocietyAttributes,
  StudentSocietyResponse,
} from 'lib/models/student-society';
import { parseResponse } from 'lib/utils/parser';

export const getProcessedDate = (date: Date, showTime?: boolean): string => {
  if (date) {
    const currentDate = new Date();
    const differenceInYear = getYear(currentDate) - getYear(date);
    const differenceInDay = differenceInDays(currentDate, date);
    const differenceInHr = differenceInHours(currentDate, date);
    const differenceInMin = differenceInMinutes(currentDate, date);

    if (differenceInYear > 0) {
      return format(date, showTime ? 'PPp' : 'PP');
    } else if (differenceInDay >= 7) {
      return format(date, showTime ? 'MMM dd, p' : 'MMM dd');
    } else if (differenceInDay > 1 && differenceInDay < 7) {
      return format(date, `EEEE${showTime ? ', p' : ''}`);
    } else if (differenceInDay === 1) {
      return `Yesterday${showTime ? `, ${format(date, 'p')}` : ''}`;
    } else if (differenceInHr >= 1 && differenceInHr < 24) {
      return `${differenceInHr.toFixed(0)}${differenceInHr > 1 ? 'hrs' : 'hr'}`;
    } else if (differenceInMin >= 1 && differenceInMin < 60) {
      return `${differenceInMin.toFixed(0)}m`;
    } else if (differenceInMin < 1) {
      return 'Now';
    }
  }
  return '';
};

export const getDisplayName = (room: RoomAttributes): string => {
  const { created_for_type, receiver } = room || {};

  if (created_for_type === null) {
    if (receiver?.data?.type && receiver?.data?.type === 'company') {
      const { name } = parseResponse(receiver as CompanyResponse);
      return name;
    } else if (
      receiver?.data?.type &&
      receiver?.data?.type === 'student_society'
    ) {
      const { name } = parseResponse(receiver as StudentSocietyResponse);
      return name;
    }
  } else {
    const { title, creatable_for } = parseResponse(
      receiver as OpportunityResponse
    );
    const createdBy = parseResponse<
      CompanyAttributes | StudentSocietyAttributes
    >(creatable_for);

    return `${createdBy.name} - ${title}`;
  }
  return '';
};
